var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPaperAirplane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4467 32.6451C38.6354 32.9424 38.5918 33.3309 38.3419 33.5791L19.5882 52.2052C19.3361 52.4555 18.943 52.4947 18.6465 52.299C18.35 52.1034 18.2315 51.7265 18.3626 51.3963L23.8387 37.6026C23.9177 37.4036 24.0781 37.2478 24.2793 37.1746L37.5569 32.3422C37.8878 32.2217 38.258 32.3477 38.4467 32.6451ZM25.1086 38.469L21.0847 48.6047L34.8651 34.9181L25.1086 38.469Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0596 34.7934V51.6735L24.5357 37.8798L48.1415 14.0771L19.0596 34.7934Z",
    fill: "#EA5504"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7131 13.5916C48.9652 13.8884 48.9483 14.3288 48.674 14.6053L25.1762 38.299L19.7566 51.9502C19.6239 52.2847 19.2722 52.4777 18.9187 52.4101C18.5652 52.3425 18.3096 52.0334 18.3096 51.6735V34.7934C18.3096 34.5508 18.4269 34.3233 18.6244 34.1825L47.7064 13.4663C48.0236 13.2404 48.4609 13.2948 48.7131 13.5916ZM19.8096 35.18V47.7517L23.8386 37.603C23.876 37.509 23.9319 37.4235 24.0032 37.3517L41.4323 19.7773L19.8096 35.18Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 26.7253L19.0594 34.793L48.1414 14.0768L24.5356 37.8794L44.0091 48.8589L54.6846 7.75L4.75 26.7253Z",
    fill: "#EA5504"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1852 7.19156C55.3941 7.37882 55.481 7.667 55.4105 7.93853L44.7351 49.0475C44.6765 49.2728 44.5167 49.4582 44.3023 49.5493C44.088 49.6403 43.8436 49.6266 43.6408 49.5123L24.1673 38.5328C23.9634 38.4178 23.8249 38.2144 23.7927 37.9827C23.7605 37.7509 23.8383 37.5174 24.0031 37.3513L41.4322 19.7769L19.4946 35.4039C19.2577 35.5727 18.9445 35.5892 18.6911 35.4464L4.38167 27.3787C4.12822 27.2358 3.98029 26.9592 4.00212 26.6691C4.02396 26.3789 4.21162 26.1276 4.48359 26.0243L54.4182 7.04893C54.6804 6.94928 54.9763 7.00431 55.1852 7.19156ZM6.51235 26.858L19.0126 33.9056L47.7063 13.466C48.0235 13.24 48.4608 13.2944 48.713 13.5912C48.9651 13.888 48.9482 14.3284 48.6739 14.605L25.7607 37.7092L43.5283 47.7268L53.5937 8.96688L6.51235 26.858Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaperAirplane);
export default __webpack_public_path__ + "static/media/icon_paper_airplane.fbf01cfe3c5112b52c2d3f80ccc15909.svg";
export { ForwardRef as ReactComponent };